import useTranslation from '../useTranslation';
import { useEffect, useState } from 'react';

import type { Props, UseData } from './types';

const useData = ({ onNext, rows }: Props): UseData => {
    const { NO_DRONES, NO_MORE_DRONES } = useTranslation();

    const [hasNextPage, setHasNextPage] = useState(false);
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!initialized) {
            const hasNext = typeof onNext === 'function';

            setHasNextPage(hasNext);

            if (hasNext) {
                setInitialized(true);
            }
        }
    }, [initialized, onNext]);

    const fetchNext = async () => {
        if (!hasNextPage || !onNext) {
            return;
        }

        const { done } = await onNext();

        setHasNextPage(!done);
    };

    const endingMessage = rows.length === 0 ? NO_DRONES : NO_MORE_DRONES;

    return {
        endingMessage,
        fetchNext,
        hasNextPage
    };
};

export default useData;
